import { Components, outlinedInputClasses, Theme } from '@mui/material';

export const MuiOutlinedInput: Components<Theme>['MuiOutlinedInput'] = {
  styleOverrides: {
    root: ({ theme }) => {
      if (theme.featureFlags.panwRebrandStubYear) {
        return {
          borderRadius: theme.shape.controlRadius,
          [`&.${outlinedInputClasses.focused}:not(.${outlinedInputClasses.disabled}) .${outlinedInputClasses.notchedOutline}`]:
            {
              border: `2px solid ${theme.palette.border.highlight}`,
            },
          [`&:hover:not(.${outlinedInputClasses.disabled}):not(.${outlinedInputClasses.focused}) .${outlinedInputClasses.notchedOutline}`]:
            {
              border: `1px solid ${theme.palette.border.bold}`,
            },
          [`&.${outlinedInputClasses.disabled} .${outlinedInputClasses.notchedOutline}`]: {
            borderColor: `${theme.palette.border.disabled}`,
          },
          [`&.${outlinedInputClasses.error} .${outlinedInputClasses.notchedOutline}, &.${outlinedInputClasses.error}:hover:not(.${outlinedInputClasses.focused}) .${outlinedInputClasses.notchedOutline}`]:
            {
              border: `1px solid ${theme.palette.input.errorColor} !important`,
            },
          [`&.${outlinedInputClasses.error}.${outlinedInputClasses.focused} .${outlinedInputClasses.notchedOutline}`]: {
            border: `2px solid ${theme.palette.input.errorColor} !important`,
          },
        };
      }
      return {};
    },
    notchedOutline: ({ theme }) => ({
      borderColor: theme.featureFlags.panwRebrandStubYear
        ? theme.palette.border.default
        : theme.palette.input.borderColor,
    }),
  },
};
